import { render, staticRenderFns } from "./GamesPage.vue?vue&type=template&id=3d2c01ca&scoped=true"
import script from "./GamesPage.vue?vue&type=script&lang=ts"
export * from "./GamesPage.vue?vue&type=script&lang=ts"
import style0 from "./GamesPage.vue?vue&type=style&index=0&id=3d2c01ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2c01ca",
  null
  
)

export default component.exports